export const SET_LOADING = 'SET_LOADING'
export const SET_MODULOS = 'SET_MODULOS'

export const url = '/apiusuariorol/'